import React from "react";

type AddWorkModalHeaderProps = {
  onClose: () => void;
};

export const AddWorkModalHeader: React.FC<AddWorkModalHeaderProps> = ({
  onClose,
}) => {
  return (
    <div
      className={
        "grid grid-cols-[1fr_max-content] border-b border-gray-300 px-6 py-2 text-base font-semibold"
      }>
      <div className={"flex items-center justify-start text-[16px]"}>
        New work
      </div>
      <button
        type={"button"}
        className={"close-popup cursor-pointer text-end"}
        onClick={onClose}>
        <img src={"/img/closse.png"} alt={""} />
      </button>
    </div>
  );
};
